// SHADOW MARKET™ — Patrones Gráficos
// Data layer for the 16 chart-pattern lessons displayed inside the Academy.

export const PATRONES = [
  {
    id: "bandera-alcista",
    nombre: "Bandera Alcista",
    tipo: "continuacion",
    direccion: "alcista",
    nivel: "basico",
    descripcion:
      "Patrón de continuación alcista formado por un impulso fuerte al alza (el asta) seguido de una corrección en un canal bajista paralelo (la bandera). Indica una pausa antes de que la tendencia continúe al alza.",
    estructura: [
      "Asta: impulso alcista fuerte",
      "Canal correctivo bajista paralelo (la bandera)",
      "Ruptura al alza del canal con volumen",
    ],
    objetivo: "La altura del asta proyectada hacia arriba desde el punto de ruptura.",
    consejo:
      "Busca volumen decreciente durante la bandera y aumento en la ruptura. Más fiable en marcos de 4H o diario. Muy frecuente en BTC tras noticias positivas.",
  },
  {
    id: "bandera-bajista",
    nombre: "Bandera Bajista",
    tipo: "continuacion",
    direccion: "bajista",
    nivel: "basico",
    descripcion:
      "Patrón de continuación bajista. Un impulso descendente fuerte (asta) seguido de una corrección al alza en canal paralelo (bandera). Señal de continuación de la tendencia bajista.",
    estructura: [
      "Asta: impulso bajista fuerte",
      "Canal correctivo alcista paralelo",
      "Ruptura a la baja del canal",
    ],
    objetivo: "La altura del asta proyectada hacia abajo desde el punto de ruptura.",
    consejo:
      "El canal correctivo debe mantenerse por debajo del 50% del asta. Si supera ese nivel el patrón pierde fiabilidad.",
  },
  {
    id: "banderin-alcista",
    nombre: "Banderín Alcista",
    tipo: "continuacion",
    direccion: "alcista",
    nivel: "basico",
    descripcion:
      "Similar a la bandera alcista pero la corrección forma un triángulo convergente en vez de un canal paralelo. La consolidación es más compacta y la ruptura suele ser más explosiva.",
    estructura: [
      "Asta: impulso alcista",
      "Triángulo convergente de consolidación",
      "Ruptura al alza del triángulo",
    ],
    objetivo: "La altura del asta proyectada desde el vértice del triángulo hacia arriba.",
    consejo:
      "El triángulo debe formarse en la mitad superior del asta. Cuanto más cerca del vértice sea la ruptura, más potente suele ser el movimiento.",
  },
  {
    id: "banderin-bajista",
    nombre: "Banderín Bajista",
    tipo: "continuacion",
    direccion: "bajista",
    nivel: "basico",
    descripcion:
      "Versión bajista del banderín. El triángulo convergente se forma tras un impulso bajista fuerte. Señal de continuación: la ruptura a la baja confirma el movimiento.",
    estructura: [
      "Asta: impulso bajista",
      "Triángulo convergente de consolidación",
      "Ruptura a la baja del triángulo",
    ],
    objetivo: "La altura del asta proyectada hacia abajo desde el vértice.",
    consejo:
      "Confirma con aumento de volumen en la ruptura. Los banderines en marcos cortos (15min-1H) son muy frecuentes en cripto.",
  },
  {
    id: "taza-asa",
    nombre: "Taza con Asa",
    tipo: "continuacion",
    direccion: "alcista",
    nivel: "intermedio",
    descripcion:
      "Corrección suave en forma de U (la taza) seguida de una pequeña consolidación bajista (el asa). Uno de los patrones más estudiados en mercados alcistas.",
    estructura: [
      "Impulso alcista previo",
      "Corrección en forma de U (la taza)",
      "Pequeña corrección bajista (el asa)",
      "Ruptura por encima de la resistencia",
    ],
    objetivo: "La profundidad de la taza proyectada hacia arriba desde el nivel de resistencia.",
    consejo:
      "La taza debe ser redondeada (U), no en V. El asa no debe corregir más del 50% de la taza. Muy habitual en BTC en marcos semanales.",
  },
  {
    id: "taza-asa-invertida",
    nombre: "Taza con Asa Invertida",
    tipo: "continuacion",
    direccion: "bajista",
    nivel: "intermedio",
    descripcion:
      "Versión bajista. La corrección forma una cúpula invertida seguida de una pequeña corrección alcista. Señal de continuación bajista.",
    estructura: [
      "Impulso bajista previo",
      "Corrección en forma de U invertida (cúpula)",
      "Pequeña corrección alcista (asa)",
      "Ruptura bajista del soporte",
    ],
    objetivo: "La profundidad de la cúpula proyectada hacia abajo desde el soporte.",
    consejo:
      "Frecuente en mercados bajistas prolongados. Confirmar con volumen creciente en la ruptura a la baja.",
  },
  {
    id: "doble-techo",
    nombre: "Doble Techo",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "basico",
    descripcion:
      "Dos máximos consecutivos al mismo nivel con un mínimo intermedio. Señal de que los compradores no pueden superar esa resistencia. La ruptura bajo la línea de cuello confirma la reversión.",
    estructura: [
      "Primer máximo",
      "Corrección hasta la línea de cuello",
      "Segundo máximo al mismo nivel",
      "Ruptura bajista de la línea de cuello",
    ],
    objetivo: "Distancia entre el máximo y la línea de cuello, proyectada hacia abajo.",
    consejo:
      "El segundo máximo con menor volumen aumenta la fiabilidad. Confirmar con cierre bajo la línea de cuello.",
  },
  {
    id: "doble-suelo",
    nombre: "Doble Suelo",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "basico",
    descripcion:
      "Dos mínimos consecutivos al mismo nivel con un máximo intermedio. Los vendedores no pueden empujar el precio bajo ese soporte. Ruptura alcista de la línea de cuello confirma la reversión.",
    estructura: [
      "Primer mínimo",
      "Rebote hasta la línea de cuello",
      "Segundo mínimo al mismo nivel",
      "Ruptura alcista de la línea de cuello",
    ],
    objetivo: "Distancia entre el mínimo y la línea de cuello, proyectada hacia arriba.",
    consejo:
      "Segundo mínimo con menor volumen es señal positiva. Confirmar con cierre por encima de la línea de cuello.",
  },
  {
    id: "triple-techo",
    nombre: "Triple Techo",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "intermedio",
    descripcion:
      "Tres máximos al mismo nivel. Más fiable que el doble techo. Cada intento fallido de superar la resistencia incrementa la presión vendedora.",
    estructura: [
      "Tres máximos consecutivos al mismo nivel",
      "Dos correcciones intermedias",
      "Ruptura bajo la línea de cuello",
    ],
    objetivo: "Distancia entre el máximo y la línea de cuello, proyectada hacia abajo.",
    consejo: "Cuanto más tiempo tarde en formarse, más potente suele ser la caída posterior.",
  },
  {
    id: "triple-suelo",
    nombre: "Triple Suelo",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "intermedio",
    descripcion:
      "Tres mínimos al mismo nivel. Una de las señales de reversión alcista más potentes. El soporte se refuerza con cada rebote.",
    estructura: [
      "Tres mínimos consecutivos al mismo nivel",
      "Dos rebotes intermedios",
      "Ruptura por encima de la línea de cuello",
    ],
    objetivo: "Distancia entre el mínimo y la línea de cuello, proyectada hacia arriba.",
    consejo:
      "En cripto, los triples suelos en soporte de largo plazo marcan con frecuencia suelos de mercado importantes.",
  },
  {
    id: "cabeza-hombros",
    nombre: "Cabeza y Hombros",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "basico",
    descripcion:
      "El patrón de reversión más conocido. Tres máximos: el central (cabeza) supera a los dos exteriores (hombros) que están al mismo nivel. Ruptura bajo la línea de cuello confirma la reversión bajista.",
    estructura: [
      "Hombro izquierdo",
      "Cabeza (máximo superior)",
      "Hombro derecho (≈mismo nivel que el izquierdo)",
      "Línea de cuello + ruptura bajista",
    ],
    objetivo: "Distancia entre la cabeza y la línea de cuello, proyectada desde la ruptura.",
    consejo:
      "Línea de cuello inclinada al alza es más bajista. Volumen elevado en la ruptura confirma el patrón.",
  },
  {
    id: "cabeza-hombros-inversos",
    nombre: "C&H Inversos",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "basico",
    descripcion:
      "Versión alcista del cabeza y hombros. Tres mínimos donde el central (cabeza) es el más bajo. La ruptura por encima de la línea de cuello señala una reversión alcista potente.",
    estructura: [
      "Hombro izquierdo",
      "Cabeza (mínimo inferior)",
      "Hombro derecho (≈mismo nivel que el izquierdo)",
      "Línea de cuello + ruptura alcista",
    ],
    objetivo: "Distancia entre la cabeza y la línea de cuello, proyectada hacia arriba.",
    consejo:
      "Uno de los patrones más fiables para identificar suelos. Busca volumen creciente en el hombro derecho y en la ruptura.",
  },
  {
    id: "cuna-ascendente",
    nombre: "Cuña Ascendente",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "intermedio",
    descripcion:
      "Canal convergente inclinado al alza. Ambas líneas suben pero convergen: el precio tiene cada vez menos espacio para subir. Señal de reversión bajista.",
    estructura: [
      "Línea de resistencia alcista",
      "Línea de soporte alcista (con mayor pendiente)",
      "Convergencia de ambas líneas",
      "Ruptura a la baja",
    ],
    objetivo: "Altura de la base de la cuña proyectada hacia abajo desde el punto de ruptura.",
    consejo:
      "Las cuñas ascendentes aparecen frecuentemente al final de impulsos alcistas. Son señales de distribución institucional.",
  },
  {
    id: "cuna-descendente",
    nombre: "Cuña Descendente",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "intermedio",
    descripcion:
      "Canal convergente inclinado a la baja. La presión vendedora se reduce con cada mínimo. Señal de reversión alcista: la ruptura al alza suele ser potente.",
    estructura: [
      "Línea de resistencia bajista",
      "Línea de soporte bajista (con menor pendiente)",
      "Convergencia de ambas líneas",
      "Ruptura al alza",
    ],
    objetivo: "Altura de la base de la cuña proyectada hacia arriba desde el punto de ruptura.",
    consejo:
      "Las cuñas descendentes en correcciones de tendencia alcista son señales de continuación muy fiables en BTC/ETH.",
  },
  {
    id: "triangulo",
    nombre: "Triángulo Simétrico",
    tipo: "neutro",
    direccion: "neutro",
    nivel: "basico",
    descripcion:
      "Zona de consolidación con máximos decrecientes y mínimos crecientes. El precio se comprime hasta que la energía produce una ruptura. La dirección de la ruptura determina el objetivo.",
    estructura: [
      "Línea de resistencia bajista",
      "Línea de soporte alcista",
      "Convergencia hacia un vértice",
      "Ruptura (dirección indeterminada)",
    ],
    objetivo: "Altura de la base del triángulo proyectada en la dirección de la ruptura.",
    consejo:
      "El contexto determina la probabilidad: un triángulo en tendencia alcista suele romper al alza. Siempre confirma con cierre de vela fuera.",
  },
  {
    id: "rectangulo",
    nombre: "Rectángulo",
    tipo: "neutro",
    direccion: "neutro",
    nivel: "basico",
    descripcion:
      "El precio oscila entre un soporte y una resistencia horizontales. Zona de acumulación o distribución. La dirección de la ruptura determina el sesgo y el objetivo.",
    estructura: [
      "Resistencia horizontal",
      "Soporte horizontal",
      "Oscilaciones entre ambas",
      "Ruptura (dirección indeterminada)",
    ],
    objetivo: "Altura del rectángulo proyectada en la dirección de la ruptura.",
    consejo:
      "En cripto, los rectángulos largos con volumen creciente en los mínimos suelen preceder rupturas alcistas potentes (acumulación institucional).",
  },
];

export const TIPOS = ["continuacion", "reversion", "neutro"];
export const NIVELES = ["basico", "intermedio"];

export const TIPO_LABEL = {
  continuacion: "Continuación",
  reversion: "Reversión",
  neutro: "Neutro",
};

export const DIRECCION_LABEL = {
  alcista: "Alcista",
  bajista: "Bajista",
  neutro: "Neutro",
};

export const NIVEL_LABEL = {
  basico: "Básico",
  intermedio: "Intermedio",
};

export function getPatron(id) {
  return PATRONES.find((p) => p.id === id) || null;
}

export function filtrarPatrones(tipo, nivel) {
  return PATRONES.filter((p) => {
    if (tipo && tipo !== "todos" && p.tipo !== tipo) return false;
    if (nivel && nivel !== "todos" && p.nivel !== nivel) return false;
    return true;
  });
}
